export default __webpack_public_path__ + "static/media/aiability.023b9314.png";